import { f as _objectSpread2, j as _slicedToArray } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';

// #region Popup
var popupStyles = function popupStyles(props) {
  var position = props.position,
    active = props.active,
    childrenPresent = props.childrenPresent,
    variant = props.variant,
    theme = props.theme,
    header = props.header,
    mode = props.mode,
    width = props.width;
  return _objectSpread2({
    border: "1px solid ".concat(theme.colors.grey.haptik),
    maxWidth: width || 273,
    width: childrenPresent ? 170 : "100%",
    background: theme.colors.grey.pastel,
    // eslint-disable-next-line no-nested-ternary
    padding: header ? 0 : variant !== "select" ? theme.space.md : "".concat(theme.space.md, "px 0 0"),
    flexDirection: "column",
    alignItems: "center",
    borderRadius: theme.radii.sm,
    maxHeight: mode === "smartSkill" ? 525 : 488,
    height: childrenPresent ? 24 : "auto",
    justifyContent: "end",
    overflowY: "hidden",
    overflowX: "hidden",
    position: "fixed",
    zIndex: 99999999,
    top: 69,
    // Nice
    transition: "all 0.2s ease",
    boxShadow: "0px 6px 20px 0px #00000033",
    transform: "translateY(".concat(active ? "0" : "-10px", ")"),
    opacity: active ? "1" : "0"
  }, position);
};
var StyledPopup = styled(Box)(popupStyles);
// #endregion

// #region Popup Header
var popupHeaderStyles = function popupHeaderStyles() {
  return {
    border: 0,
    width: "-webkit-fill-available",
    padding: "12px 12px 8px 12px",
    cursor: "pointer",
    fontWeight: 600,
    zIndex: 2
  };
};
var StyledPopupHeader = styled(Box)(popupHeaderStyles);
// #endregion

// #region Popup Inner
var popupInnerStyles = function popupInnerStyles(props) {
  return {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    padding: !props.footer && props.variant === "select" ? "0 0 8px 0" : 0,
    border: 0,
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
  };
};
var StyledPopupInner = styled(Box)(popupInnerStyles);
// #endregion

// #region Popup Footer
var popupFooterStyles = function popupFooterStyles(props) {
  return {
    border: 0,
    width: "-webkit-fill-available",
    padding: "8px 12px 12px 12px",
    cursor: "pointer",
    color: props.theme.colors.blue.haptik,
    fontWeight: 600,
    zIndex: 2
  };
};
var StyledPopupFooter = styled(Box)(popupFooterStyles);

var Popup = function Popup(props) {
  var active = props.active,
    children = props.children,
    position = props.position,
    containerRef = props.containerRef,
    header = props.header,
    footer = props.footer,
    footerProps = props.footerProps,
    variant = props.variant,
    mode = props.mode,
    preventCloseOn = props.preventCloseOn,
    width = props.width;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isActive = _React$useState2[0],
    setIsActive = _React$useState2[1];
  var handleClickOutside = React.useCallback(function (event) {
    // used for internal tabs within topbar to switch between bots and smart skills
    var preventCloseElem = document.getElementById(preventCloseOn);
    if (preventCloseElem && preventCloseElem !== null) {
      var _event$target$parentE;
      if (event.target === document.getElementById(preventCloseOn) || event.target.parentElement === document.getElementById(preventCloseOn) || ((_event$target$parentE = event.target.parentElement) === null || _event$target$parentE === void 0 ? void 0 : _event$target$parentE.parentElement) === document.getElementById(preventCloseOn)) {
        return null;
      }
    }
    if (containerRef !== null && containerRef !== void 0 && containerRef.current && !(containerRef !== null && containerRef !== void 0 && containerRef.current.contains(event.target))) {
      props.onActiveChange(false);
    }
  }, []);
  React.useEffect(function () {
    if (active) {
      document.addEventListener("click", handleClickOutside, false);
    } else {
      document.removeEventListener("click", handleClickOutside, false);
    }
    setTimeout(function () {
      setIsActive(active);
    }, 100);
  }, [active]);
  return active ? /*#__PURE__*/React.createElement(StyledPopup, {
    active: isActive,
    header: header,
    position: {
      left: position.left,
      top: position.top
    },
    variant: variant,
    childrenPresent: !children || children.length === 0,
    "data-testid": "topbar-popup",
    id: "custom-popup",
    mode: mode,
    width: width
  }, header && /*#__PURE__*/React.createElement(StyledPopupHeader, null, header), /*#__PURE__*/React.createElement(StyledPopupInner, {
    footer: footer,
    variant: variant
  }, children), footer && /*#__PURE__*/React.createElement(StyledPopupFooter, {
    onClick: footerProps.onClick
  }, /*#__PURE__*/React.createElement(Text, null, footerProps.title))) : null;
};
Popup.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.element,
  position: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }),
  containerRef: PropTypes.element,
  header: PropTypes.node,
  footer: PropTypes.bool,
  footerProps: PropTypes.shape({
    title: PropTypes.string,
    onClick: PropTypes.func
  }),
  variant: PropTypes.string,
  mode: PropTypes.string,
  preventCloseOn: PropTypes.string,
  onActiveChange: PropTypes.func,
  width: PropTypes.number
};

export default Popup;
